<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row mt-3">
        <div class="col-12">
          <card class="strpied-tabled-with-hover"
                body-classes="table-full-width table-responsive"
          >
            <template slot="header">
              <b-row class="mb-2">
                <b-col lg="3">
                  <label class="small mb-1">Owner</label>
                  <b-form-select v-model="filterUserId" :options="ownerUserOptions" size="sm"></b-form-select>
                </b-col>
                <b-col lg="1" class="d-flex align-items-end">
                  <b-button size="sm" variant="outline-secondary" @click="resetFilters">Reset</b-button>
                </b-col>
                <b-col lg="2" class="d-flex align-items-end">
                  <b-button size="sm" variant="success" class="mr-1" @click="exportExcel"><b-icon icon="file-earmark-excel"></b-icon> Excel</b-button>
                  <b-button size="sm" variant="danger" @click="exportPDF"><b-icon icon="file-earmark-pdf"></b-icon> PDF</b-button>
                </b-col>
                <b-col lg="4" class="my-1">
                  <b-form-group class="mb-0">
                    <b-input-group size="sm">
                      <b-form-input v-model="filter" type="search" placeholder="Search"></b-form-input>
                      <b-input-group-append>
                        <b-button class="btn-secondary" :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
            </template>
            
            <template>
              <div class="table-container">
              <b-table-simple
                :small="true"
                sticky-header
                style="max-height: 395px;"
                striped
                responsive
                hover
              >
                <b-thead>
                  <b-tr>
                    <b-th>No.</b-th>
                    <b-th>Name</b-th>
                    <b-th>Location</b-th>
                    <b-th>Bill Exist</b-th>
                    <b-th>Electric Bill Option</b-th>
                    <b-th>Water Bill Option</b-th>
                    <b-th>Bill Payment Period</b-th>
                    <b-th>Bldg Owner</b-th>
                    <b-th>Created At</b-th>
                    <b-th>Created By</b-th>
                    <b-th>Creator Phone Number</b-th>
                  </b-tr>
                </b-thead>
                <template v-if="spinner">
                <b-tbody class="text-center">
                   <b-tr >
                       <b-td colspan="11" class="text-center" style="display: table-cell">
                        <b-spinner
                        style="height: 3rem; width: 3rem;"
                          variant="warning"
                        ></b-spinner>
                       </b-td>
                    </b-tr>
                </b-tbody>
                </template>
                <template v-else>
                  <b-tbody>
                  <template v-if="filterTable.length === 0">
                      <b-tr>
                        <b-td colspan="11" class="text-center">Nothing found</b-td>
                      </b-tr>
                  </template>
                  <template v-else>
                  <b-tr
                    v-for="(item, index) in filterTable"
                    :key="item.buildingId"
                    @click="viewBuildingDetail(item.buildingId)"
                    style="cursor: pointer;"
                  >
                      <b-td>{{(currentPage - 1) * perPage + index + 1}}</b-td>
                      <b-td>{{item.buildingName}}</b-td>
                      <b-td>{{item.location}}</b-td>
                      <b-td>
                        <b-badge :variant="item.billExist === 'yes' ? 'success' : 'secondary'">
                          {{item.billExist === 'yes' ? 'Yes' : 'No'}}
                        </b-badge>
                      </b-td>
                      <b-td>{{formatBillOption(item.electricBillAmountOption)}}</b-td>
                      <b-td>{{formatBillOption(item.waterBillAmountOption)}}</b-td>
                      <b-td>{{formatBillPeriod(item.billPaymentPeriod)}}</b-td>
                      <b-td>{{item.buildingOwner}}</b-td>
                      <b-td>{{formatDate(item.createdDate)}}</b-td>
                      <b-td>{{item.registeredBy}}</b-td>
                      <b-td>{{item.creatorPhoneNumber}}</b-td>
                  </b-tr>
                  </template>
                </b-tbody>
                </template>
              </b-table-simple>
              </div>
              <div class="pagination-container mt-2">
              <b-row>
                <b-col md="3">
                  <b-form-group
                    id="fieldset-horizontal"
                    label-cols="8" label-cols-xs="8" label-size="md"
                    label="records per page"
                    label-for="input-horizontal"
                    label-align-xl="right"  
                  >
                  <b-form-select id="input-horizontal" v-model="perPage" :options="pageOptions" @change="changePerPage"></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col md="9">
                  <b-pagination v-model="currentPage" :per-page="perPage" :total-rows="displayRows" @page-click="changePage" align="right"></b-pagination>
                </b-col>
              </b-row>
              </div>
            </template>
          </card>
        </div>
      </div>
      
      <!-- Detail View Modal -->
      <div class="row">
        <b-modal
            id="modal-building-detail"
            size="lg"
            hide-footer
            title="Building Details"
            content-class="shadow" 
          >
            <template #modal-header="{ close }">
              <h5>Building Details</h5>
              <p class="h5 mb-2">
                <b-icon
                  icon="x-square"
                  class="close-icon"
                  @click="close"
                ></b-icon>
              </p>
            </template>
            <div v-if="selectedBuilding && selectedBuilding.buildingId">
              <b-row class="mb-3">
                <b-col md="6">
                  <b-card>
                    <h6 class="text-muted">Building Information</h6>
                    <hr>
                    <p><strong>Name:</strong> {{selectedBuilding.buildingName}}</p>
                    <p><strong>Location:</strong> {{selectedBuilding.location}}</p>
                    <p><strong>Status:</strong> 
                      <b-badge :variant="getStatusVariant(selectedBuilding.status)">
                        {{selectedBuilding.status || 'Active'}}
                      </b-badge>
                    </p>
                    <p><strong>Created At:</strong> {{formatDate(selectedBuilding.createdDate)}}</p>
                    <p><strong>Created By:</strong> {{selectedBuilding.registeredBy}}</p>
                    <p><strong>Phone:</strong> {{selectedBuilding.creatorPhoneNumber}}</p>
                  </b-card>
                </b-col>
                <b-col md="6">
                  <b-card>
                    <h6 class="text-muted">Bill Settings</h6>
                    <hr>
                    <p><strong>Electric Bill Option:</strong> {{formatBillOption(selectedBuilding.electricBillAmountOption)}}</p>
                    <p><strong>Water Bill Option:</strong> {{formatBillOption(selectedBuilding.waterBillAmountOption)}}</p>
                    <p><strong>Bill Payment Period:</strong> {{selectedBuilding.billPaymentPeriod || 'N/A'}}</p>
                    <p><strong>Bill Exist:</strong> 
                      <b-badge :variant="selectedBuilding.billExist === 'yes' ? 'success' : 'secondary'">
                        {{selectedBuilding.billExist === 'yes' ? 'Yes' : 'No'}}
                      </b-badge>
                    </p>
                  </b-card>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-card>
                    <h6 class="text-muted">Additional Information</h6>
                    <hr>
                    <p><strong>Building ID:</strong> {{selectedBuilding.buildingId}}</p>
                    <p><strong>User ID:</strong> {{selectedBuilding.user ? selectedBuilding.user.id : 'N/A'}}</p>
                  </b-card>
                </b-col>
              </b-row>
            </div>
            <div v-else class="text-center">
              <b-spinner variant="warning"></b-spinner>
              <p>Loading details...</p>
            </div>
            <b-row class="mt-3">
              <b-col class="text-right">
                <b-button variant="secondary" @click="$bvModal.hide('modal-building-detail')">
                  Close
                </b-button>
              </b-col>
            </b-row>
          </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
  import LTable from 'src/components/Table.vue'
  import Card from 'src/components/Cards/Card.vue'
  import * as XLSX from 'xlsx'
  import jsPDF from 'jspdf'
  import 'jspdf-autotable'

  export default {
    components: {
      LTable,
      Card
    },
    data () {
      return {
        modulePermission: {
          view: 1,
          create: 0,
          update: 0,
          delete: 0
        },
        totalRows: 0,
        currentPage: 1,
        perPage: 7,
        pageOptions: [
          {value: 7, text: 7},
          {value: 10, text: 10},
          {value: 25, text: 25},
          {value: 50, text: 50},
          {value: 100, text: 100}
        ],
        items: [],
        allItems: [],
        filter: "",
        selectedBuilding: {},
        spinner: true,
        filterUserId: null,
        ownerUserOptions: [{value: null, text: "All Owners"}]
      }
    },
    watch: {
      filterUserId() { this.applyFilters(); },
      filter(val) {
        if (val && val.trim()) this.fetchAllForSearch();
        else this.allItems = [];
      }
    },
    computed: {
      searchSource() {
        return this.filter && this.allItems.length ? this.allItems : this.items;
      },
      filterTable() {
        if (!this.filter) return this.items;
        const s = this.filter.trim().toLowerCase();
        return this.searchSource.filter(item => [
          item.buildingName, item.location, item.electricBillAmountOption,
          item.waterBillAmountOption, item.billPaymentPeriod, item.registeredBy,
          item.creatorPhoneNumber, item.status, item.createdDate
        ].some(v => v && String(v).toLowerCase().includes(s)));
      },
      displayRows() {
        return this.filter ? this.filterTable.length : this.totalRows;
      }
    },
    mounted() {
      this.getModules();
      this.getAllBuildingsList();
      this.getOwnerUsers();
      this.$on("AfterComplete", () => {
        this.getAllBuildingsList();
      });
    },
    methods: {
      formatBillPeriod(period) {
        if (!period || period == 0) return 'N/A';
        if (period == 1) return 'Monthly';
        return 'Every ' + period + ' Months';
      },

      formatBillOption(option) {
        if (!option) return 'N/A';
        const optionMap = {
          'none': 'No bills',
          'BySQM': 'Distribute bill with house size',
          'EqualForAllHouse': 'Distribute bill equal amount',
          'ByAmountForEachHouse': 'Define bill for each house',
          'ByReading': 'Define bill reading for each house'
        };
        return optionMap[option] || option;
      },
      
      formatDate(dateString) {
        if (!dateString) return 'N/A';
        try {
          const date = new Date(dateString);
          return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
          });
        } catch (e) {
          return dateString;
        }
      },
      
      getStatusVariant(status) {
        if (!status) return 'secondary';
        const statusMap = {
          'Active': 'success',
          'Inactive': 'danger',
          'Pending': 'warning',
          'Archived': 'secondary'
        };
        return statusMap[status] || 'secondary';
      },
      
      getModules(){
        this.$store.dispatch('getModulesPermission', {userId: sessionStorage.getItem("userID")})
          .then(response=>{
              var modulesList = response.data.modules;
              var BuildingModule = modulesList.filter(x=>x.name === "BuildingSuper");
              if(BuildingModule !== null && BuildingModule.length > 0){
                this.modulePermission.view = BuildingModule[0].listData || 0;
                this.modulePermission.create = BuildingModule[0].createData || 0;
                this.modulePermission.update = BuildingModule[0].updateData || 0;
                this.modulePermission.delete = BuildingModule[0].deleteData || 0;
              }
          })
          .catch(error=>{
              console.log(error);
          })
      },
      
      buildPayload(page) {
        const payload = { page: page || this.currentPage, line: this.perPage };
        if (this.filterUserId) payload.userId = this.filterUserId;
        return payload;
      },

      fetchAllForSearch() {
        if (!this.totalRows) return;
        const payload = this.buildPayload();
        payload.page = 1;
        payload.line = this.totalRows;
        this.$store.dispatch('getAllBuildingsList', payload)
          .then(response => { this.allItems = response.data.Contents || []; })
          .catch(error => { console.error('Error fetching all for search:', error); });
      },
      getAllBuildingsList() {
        this.spinner = true;
        this.allItems = [];
        this.$store.dispatch('getAllBuildingsList', this.buildPayload())
          .then(response => {
            this.items = response.data.Contents || [];
            this.totalRows = response.data.totalElements || 0;
            if (this.filter && this.filter.trim()) this.fetchAllForSearch();
          })
          .catch(error => { console.error('Error fetching buildings:', error); })
          .finally(() => { this.spinner = false; });
      },

      changePage(event, page) {
        this.currentPage = page;
        this.spinner = true;
        this.$store.dispatch('getAllBuildingsList', this.buildPayload(page))
          .then(response => {
            this.items = response.data.Contents || [];
            this.totalRows = response.data.totalElements || 0;
          })
          .catch(error => { console.error('Error fetching buildings:', error); })
          .finally(() => { this.spinner = false; });
      },

      changePerPage() {
        this.currentPage = 1;
        this.spinner = true;
        this.$store.dispatch('getAllBuildingsList', this.buildPayload(1))
          .then(response => {
            this.items = response.data.Contents || [];
            this.totalRows = response.data.totalElements || 0;
          })
          .catch(error => { console.error('Error fetching buildings:', error); })
          .finally(() => { this.spinner = false; });
      },

      getOwnerUsers() {
        this.$store.dispatch('getAllOwnerUsers')
          .then(response => {
            Array.from(response.data).forEach(user => {
              this.ownerUserOptions.push({ value: user.id, text: user.fullName + ' (' + user.username + ')' });
            });
          })
          .catch(error => { console.log(error); });
      },

      applyFilters() {
        this.currentPage = 1;
        this.getAllBuildingsList();
      },

      resetFilters() {
        this.filterUserId = null;
        this.filter = '';
        this.allItems = [];
        this.currentPage = 1;
        this.getAllBuildingsList();
      },
      
      viewBuildingDetail(buildingId) {
        const building = this.items.find(item => item.buildingId === buildingId);
        if (building) {
          this.selectedBuilding = { ...building };
          this.$bvModal.show('modal-building-detail');
        } else {
          this.$store.dispatch('getBuildingById', { buildingId })
            .then(response => {
              this.selectedBuilding = response.data;
              this.$bvModal.show('modal-building-detail');
            })
            .catch(error => {
              console.error('Error fetching building details:', error);
            });
        }
      },
      
      fetchAllAndExport(format) {
        if (!this.totalRows) {
          this.$notifications.notify({ message: 'No data to export.', horizontalAlign: 'center', verticalAlign: 'top', type: 'warning' });
          return;
        }
        const payload = this.buildPayload();
        payload.page = 1;
        payload.line = this.totalRows;
        this.$store.dispatch('getAllBuildingsList', payload)
          .then(response => {
            const all = response.data.Contents || [];
            if (!all.length) {
              this.$notifications.notify({ message: 'No data to export.', horizontalAlign: 'center', verticalAlign: 'top', type: 'warning' });
              return;
            }
            if (format === 'excel') this.doExportExcel(all);
            else this.doExportPDF(all);
          })
          .catch(error => { console.log('Export error:', error); });
      },

      exportExcel() { this.fetchAllAndExport('excel'); },
      exportPDF()   { this.fetchAllAndExport('pdf'); },

      doExportExcel(all) {
        const data = all.map((item, i) => ({
          'No.': i + 1,
          'Name': item.buildingName,
          'Location': item.location,
          'Bill Exist': item.billExist === 'yes' ? 'Yes' : 'No',
          'Electric Bill Option': this.formatBillOption(item.electricBillAmountOption),
          'Water Bill Option': this.formatBillOption(item.waterBillAmountOption),
          'Bill Payment Period': this.formatBillPeriod(item.billPaymentPeriod),
          'Bldg Owner': item.buildingOwner,
          'Created At': this.formatDate(item.createdDate),
          'Created By': item.registeredBy,
          'Creator Phone Number': item.creatorPhoneNumber
        }));
        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Buildings');
        XLSX.writeFile(wb, 'Buildings.xlsx');
      },

      doExportPDF(all) {
        const doc = new jsPDF({ orientation: 'landscape' });
        doc.text('Buildings List', 14, 14);
        const rows = all.map((item, i) => [
          i + 1,
          item.buildingName,
          item.location,
          item.billExist === 'yes' ? 'Yes' : 'No',
          this.formatBillOption(item.electricBillAmountOption),
          this.formatBillOption(item.waterBillAmountOption),
          this.formatBillPeriod(item.billPaymentPeriod),
          item.buildingOwner,
          this.formatDate(item.createdDate),
          item.registeredBy,
          item.creatorPhoneNumber
        ]);
        doc.autoTable({
          head: [['No.','Name','Location','Bill Exist','Electric Bill Option','Water Bill Option','Bill Payment Period','Bldg Owner','Created At','Created By','Creator Phone Number']],
          body: rows,
          startY: 20
        });
        doc.save('Buildings.pdf');
      },

      clearData(){
        this.selectedBuilding = {};
        this.$emit('AfterComplete');
      }
    }
  }
</script>

<style scoped>
.table-container {
  overflow: auto;
}
.pagination-container {
  position: relative;
  z-index: 1;
  background: #fff;
}
.b-table-sticky-column:last-child {
  right: 0;
}
.text-warning {
    color: rgba(240, 206, 13, 0.937) !important;
}
.btn-icon{
  font-size: 27px !important;
  padding: 3px 5px 3px 5px;
  width: 40px;
  color:  rgb(37, 91, 48);
  border: 2px solid rgb(37, 91, 48);
}
.btn-icon:hover,
.btn-icon:focus {
  cursor: pointer;
  background-color: rgb(37, 91, 48) !important;
  color: rgba(240, 206, 13, 0.937) !important;
  border-radius: 4px;
  transition: .4s;
}
.close-icon {
  font-size: 24px;
  color: #6c757d;
  cursor: pointer;
}
.close-icon:hover {
  color: #dc3545;
}
</style>